<template>
<div class="content">
  <div class="box-content">
    <div class="left-justifying box-head">
      <img class="logo-img" v-if="shopInfo.full_logo" :src="shopInfo.full_logo" alt="" />
      <div class="name">{{shopInfo.name}}</div>
    </div>
    <div class="input-bxo left-justifying">
      <span>￥</span> <input v-model="amount" placeholder="请输入金额" type="number" />
    </div>

  </div>
<!--  <div class="btn submit-btn">付款</div>-->
  <div style="padding: 6.66667vw 3.2vw;">
    <van-button class="btn submit-btn" :disabled="disabledBtn" @click="moneyPay">付款</van-button>
  </div>

</div>
</template>

<script>
import { getShop, payPoly } from '@/api/goods'
export default {
  name: "shop",
  data(){
    return {
      shopId: '',
      shopInfo: '',
      userAgent: '',
      amount: '',
      disabledBtn: false,
    }
  },
  created() {
    this.shopId = this.$route.params.id

    var userAgent = window.navigator.userAgent.toLowerCase();
     this.userAgent = userAgent
    if (userAgent.match(/Alipay/i) == "alipay") {

      //alert("支付宝浏览器");   

     console.log('浏览器支付宝浏览器')

    } else if (userAgent.match(/MicroMessenger/i) == "micromessenger" ) {

      // alert("微信浏览器");
      console.log('微信浏览器')


    }
    this.getDes()
  },
  methods: {
    moneyPay(){
      if (this.amount == ''){
        this.$toast('请输入金额')
        return false
      }
      this.disabledBtn = true
      let source = ''
      var userAgent = window.navigator.userAgent.toLowerCase();
      if (userAgent.match(/Alipay/i) == "alipay") {
        source = 'alipay'
        console.log('浏览器支付宝浏览器')
      } else{
          source= 'mpPay'
        console.log('微信浏览器',source)

      }
      var data = {
        source: source,
        amount: this.amount,
        shop_id: this.shopId
      }
      payPoly(data).then(res => {
        // console.log(res.data.url)
        if (res.code==200){
          this.disabledBtn = false
          var url = res.data.url
          window.location.href=url
          window.open(url)
        }else {
          this.disabledBtn = false
          this.$toast(res.message)
          // this.$router.push('/');
        }

      })
    },
    getDes(){
      getShop(this.shopId).then(res => {
        console.log(res)
        if (res.code==200){
          this.shopInfo = res.data
        }else {
          this.$toast(res.message)
          // this.$router.push('/');
        }

      })
    }
  }
}
</script>

<style lang="scss" scoped>
.box-content{
  .box-head{
    margin-bottom: 20px;text-align: center;
  }
  .logo-img{
    width: 130px;height: 130px;border-radius: 130px;border: 2px solid #F5F5F5;display: block;
    margin-right: 20px;
  }
  background: #fff;padding: 24px;
  .name{
    font-size: 30px;font-weight: bold;padding-bottom: 30px;
  }
  .add{
    padding-top: 20px;
    color: #999999;padding-bottom: 40px;
    div{
      padding-left: 20px;
    }
  }
  .input-bxo{
    font-weight:bold;border-bottom: 2px solid #F5F5F5;padding-bottom: 20px;
    span{
      font-size: 52px;
    }
    input{
      font-size: 52px;width: 600px;padding-left: 30px;border: none;
    }
  }
}
input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #BCBCBC;
}
input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #BCBCBC;
}
input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #BCBCBC;
}
input:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #BCBCBC;
}
.btn{
  width: 100%;
  height: 86px;line-height: 86px;font-size: 34px;
  background: #FDD80D;font-weight: bold;
  color: #282828;text-align: center;
  border-radius: 43px;
}
</style>
